import { createCable } from '@anycable/web';

import { getAccessToken } from 'utils/accessToken';

export default () => createCable(process.env.REACT_APP_WS_URL + '?token=' + getAccessToken());
